module.exports = __webpack_public_path__ + "img/ico-notification.bba031ea.svg";